import { useTranslation } from 'react-i18next';
import NoDataIcon from './assets/NoDataIcon';

interface NoResultsProps {
  title: string;
  subTitle: string;
  extraContainerClasses?: string;
}

export function NoResults({ title, subTitle, extraContainerClasses }: NoResultsProps) {
  const { t } = useTranslation();

  return (
    <div className={`m-20 ${extraContainerClasses ?? ''}`}>
      <NoDataIcon />
      <div className="no-data-text-wrapper">
        {title ? <h2 className="no-data-message-title">{t(title)}</h2> : null}
        {subTitle ? <p className="no-data-message-subtitle">{t(subTitle)}</p> : null}
      </div>
    </div>
  );
}
